'use client';

import { useQuery } from '@zg-rentals/react-query5';

export function usePropertyMapKey(eligible: boolean) {
  const { data, isPending } = useQuery({
    queryKey: ['property-map-config'],
    queryFn: async ({ signal }): Promise<string> => {
      const response = await fetch('/api/property-map/config', { signal });
      if (!response.ok) throw new Error('Property map configuration unavailable');
      const config: { apiKey: string } = await response.json();
      return config.apiKey;
    },
    enabled: eligible,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
  return { apiKey: eligible ? data ?? '' : '', isPending: eligible && isPending };
}
